import { i18next } from './i18next_init';

//coming from translationList.liquid
const {
  translationsUrl,
  supportedLanguages,
  excludedUrls,
  shopUrl,
  translationUrlPrefixes,
  additionalSeparator
} = window.multilingual_settings;

const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const buildDataTranslation = (text, options = {}) => {
  let langObject = {};

  try {
    langObject = JSON.parse(text);
  }
  catch (e) {
    let separator = "||";
    if(!text.includes(separator) && additionalSeparator){
      separator = additionalSeparator;
    }
    const textSplit = text.split(separator);
    

    for (let i = 0; i < textSplit.length; i++) {
      langObject[supportedLanguages[i]] = textSplit[i].replace('"', '\"');
    }
  }

  langObject = {
    ...langObject,
    ...options
  };

  return JSON.stringify(langObject)
}

const buildTextSpan = (text) => {
  const dataTranslation = buildDataTranslation(text);

  let separator = "||";
  if(!text.includes(separator) && additionalSeparator){
    separator = additionalSeparator;
  }

  const textSplit = text.split(separator);
  return "<span data-i18n='" + dataTranslation + "'>" + textSplit[0].replace('"', '\"') + "</span>";
}

/**
 * store the translations in i18next, remove the i18n attributes 
 * and creates a data-i18n-key attribute
 * 
 * Expected i18n pattern: 
 * valid json with language properties and additional options
 * ex: data-i18n='{ "fr": "french translation", "en": "english translation", "additionalOption": "something" }'
 * 
 * multiple translations can be there by separating them with ~~
 * for example images could need a translation for src and a translation for alt
 * 
 * @param {HTMLElement} $i18n_element - an html element with a data-i18n attribute
 */
let uniqueId = 0;
const storeUserTranslation = ($i18n_element) => {
  if($i18n_element.dataset.i18n) {
    const i18nDataSplit = $i18n_element.dataset.i18n.split('~~');

    let i18nKey = [];
    
    i18nDataSplit.forEach(i18nData => {
      //if string is valid json it's a user translation.
      //properties that are not a language are additional translation options (translationKeyOption)
      
      if(isJsonString(i18nData)) {
        const i18nJson = JSON.parse(i18nData);
        const translationKey = `translation-${uniqueId}`;

        supportedLanguages.forEach(lang => {
          if(i18nJson[lang]) {
            i18next.addResource(lang, 'translation', translationKey, i18nJson[lang], { keySeparator: false });

            //we remove the property to only keep the additional options
            delete i18nJson[lang];
          }
        });

        i18nKey.push(`${translationKey}${Object.keys(i18nJson).length !== 0 ? ` || ${JSON.stringify(i18nJson)}`: ""}`);
      }
      else {
        i18nKey.push(i18nData);
      }

      uniqueId++;
    });
    
    const finalTranslationKey = i18nKey.join(' ~~ ');
    $i18n_element.removeAttribute('data-i18n');
    $i18n_element.setAttribute('data-i18n-key', finalTranslationKey);
  }
  else {
    $i18n_element.removeAttribute('data-i18n');
  }
}

/**
 * Looks for data-i18n attributes in the html and store the translation in i18n
 * 
 * @param {HTMLElement} parent - Where to strart scanning for data-i18n attributes
 */
const scanHtml = (parent) => {
  return new Promise((resolve) => {
    let $toScan = parent;
    if(!$toScan) {
      $toScan = document;
    }

    const all_i18n_elements =  $toScan.querySelectorAll('[data-i18n]');

    for(let i = 0; i < all_i18n_elements.length; i++) {
      setTimeout(function() {
        const $i18n_element = all_i18n_elements[this];

        storeUserTranslation($i18n_element);

        if(this == all_i18n_elements.length - 1) {
          resolve();
        }
      }.bind(i), 0);
    }
  });
}

const translateInterpolations = (options) => {
	for (var option in options) {
		var optionValue = options[option];

		if (optionValue.indexOf && optionValue.indexOf("^^") !== -1) {
			options[option] = optionValue.split("^^")[i18next.languageIndex];
		}
	}

	return options
}

const translateElement = ($keyElement) => {
  if ($keyElement.dataset.i18nKey) {
    const keyDataSplit = $keyElement.dataset.i18nKey.split('~~');

    keyDataSplit.forEach(keyData => {
      keyData = keyData.split('||');

      const translationKey = keyData[0].trim();
      let translationOptions = {};
      if (isJsonString(keyData[1])) {
        translationOptions = translateInterpolations(JSON.parse(keyData[1].trim()));
      }

      if (i18next.exists(translationKey)) {
        const translationText = i18next.t(translationKey, translationOptions);
        if (translationOptions.hasOwnProperty('attr')) {
          if($keyElement.getAttribute(translationOptions.attr) != translationText) {
            var decodeHtmlEntityElem = document.createElement("textarea");
            decodeHtmlEntityElem.innerHTML = translationText;

            $keyElement.setAttribute(translationOptions.attr, decodeHtmlEntityElem.value);
          }
        }
        else if (translationOptions.hasOwnProperty('notHtml')) {
          if($keyElement.textContent != translationText) {
            $keyElement.textContent = translationText;
          }
        }
        else {
          if($keyElement.innerHTML != translationText) {
            $keyElement.innerHTML = translationText;
          }
        }
      }
    }); 
  } 
}

const scanHtmlAndTranslate = (parent) => {
  return new Promise((resolve) => {
    let $toScan = parent;

    if(!$toScan) {
      $toScan = document;
    }

    /*
     * scanHtmlAndTranslate can be called by the mutationObserver.
     * Sometime the mutationObserver will call this function with a
     * Text node or a Comment node.
     * In these cases we need to scan the parent element.
     * 
     * nodetype 3 === "Text node", nodetype 8 === "comment"
     */
    if($toScan.nodeType === 3 || $toScan.nodeType === 8) {
      $toScan = $toScan.parentElement;
    }

    let all_i18n_elements =  $toScan.querySelectorAll('[data-i18n]');

    //nodetype 9 == "document"
    if($toScan.nodeType !== 9 && $toScan.hasAttribute('[data-i18n]')) {
      all_i18n_elements = [$toScan];
    }

    for(let i = 0; i < all_i18n_elements.length; i++) {
      setTimeout(function() {
        const $i18n_element = all_i18n_elements[this];

        storeUserTranslation($i18n_element);
        
        translateElement($i18n_element);

        if(this == all_i18n_elements.length - 1) {
          resolve();
        }
      }.bind(i), 0);
    }
  });
}

/**
 * Will scan all the html for the data-i18n-key attributes
 * and will translate the element
 */
const translateAllHtml = (parent) => {
  return new Promise((resolve) => {
    let $toScan = parent;
    if (!$toScan) {
      $toScan = document;
    }

    const all_i18n_keys = $toScan.querySelectorAll('[data-i18n-key]');

    for (let i = 0; i < all_i18n_keys.length; i++) {
      setTimeout(function () {
        const $keyElement = all_i18n_keys[this];

        translateElement($keyElement);
        if (this == all_i18n_keys.length - 1) {
          resolve();
        }
      }.bind(i), 0);
    }
  })
}

const translateUrl = (url) => {
  if(url) {
    var urlVerifier = /(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]*/igm;
    var isDomainAndCurrentWebsite = (url.match(urlVerifier) && url.includes(shopUrl)) || !url.match(urlVerifier);

    
    if(
      isDomainAndCurrentWebsite && 
      url && 
      url.indexOf("#") != 0 && 
      url.indexOf('tel:') == -1 && 
      url.indexOf('mailto:') == -1 && 
      url.indexOf('javascript:') == -1){
        
      let urlWithoutDomain = url.replace(shopUrl, "");
      if(urlWithoutDomain == ""){
        urlWithoutDomain = "/"
      }

      const prefixKeys = Object.keys(translationUrlPrefixes);

      let urlWithoutPrefix = urlWithoutDomain;
      prefixKeys.forEach(function(key){
        var prefix = translationUrlPrefixes[key];

        if(prefix != '/'){
          if(urlWithoutPrefix.endsWith(prefix)){
            //ex: "/en" will become "/"
            urlWithoutPrefix = urlWithoutPrefix.replace(prefix, "");
          }
          else{
            //ex: "/en/products" will become "/products"
            urlWithoutPrefix = urlWithoutPrefix.replace(prefix + "/", "/");
          }
        }
      });

      const currentPrefix = translationUrlPrefixes[i18next.language];

      let newUrl = urlWithoutPrefix;
      if(currentPrefix != '/') {
        newUrl = currentPrefix + urlWithoutPrefix;
      }

      if(newUrl == ''){
        newUrl = '/'
      }

      return newUrl;
    }
  }
}

const translateAllUrl = () => {
  const allUrlElements = document.querySelectorAll('a');

  for(let i = 0; i < allUrlElements.length; i++) {
    setTimeout(function() {
      const $urlElement = allUrlElements[this];
      const href = $urlElement.getAttribute('href');

      if(!excludedUrls.includes(href)) {
        const newUrl = translateUrl(href);
        if(newUrl) {
          $urlElement.href = newUrl;
        }
        
      }
    }.bind(i), 0);
  }

  const actionsToTranslate = document.querySelectorAll("[action*='/search'], [action*='/cart']");
  for(let i = 0; i < actionsToTranslate.length; i++) {
    setTimeout(function() {
      const $formElement = actionsToTranslate[this];
      const action = $formElement.getAttribute('action');

      if(!excludedUrls.includes(action)) {
        const newUrl = translateUrl(action);
        if(newUrl) {
          $formElement.action = newUrl;
        }
        
      }
    }.bind(i), 0);
  }

  const newUrl = new URL(document.querySelector(`[rel="alternate"][hreflang^="${i18next.language}"]`).href);
  history.pushState(null, null, newUrl.toString().replace(newUrl.origin, window.location.origin));
}

const loadLanguageAsset = async (lang) => {
  const response = await fetch(translationsUrl[lang]);
  const langObject = await response.json();

  return langObject;
}

/**
 * 
 * @param {String} lang - language to load
 * @param {Boolean} translate - if the html should be translated after loading the language
 */
const loadLanguage = async (lang, translate) => {
  if(!i18next.loadedLanguages.includes(lang)) {
    const languageResource = await loadLanguageAsset(lang)
    i18next.addResourceBundle(lang, 'translation', languageResource);

    i18next.loadedLanguages.push(lang);
  }

  if(translate){
    await translateAllHtml();

    /**
    * We dispatch an event in the html so that it can be listened from outside
    */
    var event = new CustomEvent("languageChanged");
    document.querySelector('html').dispatchEvent(event);

    translateAllUrl();
  }
}

const languageSelectorInteractions = () => {
  const languageSelectors = document.querySelectorAll(".language-selector");
  languageSelectors.forEach($selector => {
    if($selector.nodeName === 'SELECT') {
      $selector.addEventListener('change', event => {
        i18next.changeLanguage(event.target.value);
      });
    }
    else {
      $selector.addEventListener('click', event => {
        const $selector = event.currentTarget;
        const { lang } = $selector.dataset;

        i18next.changeLanguage(lang);
      });

      i18next.on('languageChanged', () => {
        languageSelectors.forEach($selector => {
          const selectorLang = $selector.dataset.lang;
          if(selectorLang === i18next.language) {
            $selector.classList.add('hide');
          }
          else {
            $selector.classList.remove('hide');
          }
        });
      })
    }
  });
}

export {
  loadLanguage,
  languageSelectorInteractions,
  scanHtml,
  scanHtmlAndTranslate,
  translateAllHtml,
  buildDataTranslation,
  buildTextSpan
}
